
import { Component, Vue, Watch } from 'vue-property-decorator'
import { companyMsgOTD, GetCompanyDtl, accountListOTD, getBankListInfo, addressListOTD, ModifyCompanyBase } from '@/api/company'
import { downloadUrl } from '@/utils/util'
import { getSyDictDataInfo, DictDataDto } from '@/api/commonConfig'
import AddrPopup from '@/views/company/template/AddrPopup.vue'
import { openAddressbook, backToBefore, LoginReturnDataDto } from '@/utils/h5ToApp'
import videojs from 'video.js'
import { Getter } from 'vuex-class'

@Component({
  components: { AddrPopup}
})
export default class CompanyMsgDetail extends Vue {
  @Getter info!: any
  companyMsg: companyMsgOTD = {addressList: []}

  isEdit = false

  alreadyEdit = false //是否用户编辑了当前页面内容

  showIndustryPicker = false // 行业类别弹框

  industryList: Array<DictDataDto> = [] // 行业类别选择内容
  banckCards = [] // 银行类型
  created () {
    this.getCompanyDtl()
    this.dictList()
    this.getBanckCards()
  }

  mounted(){
    // 注册原生调用h5返回事件
    this.handleAppBack()
  }

  @Watch('companyMsg', {deep: true, immediate: false})
  onMsgChange () {
    if(this.isEdit){
      this.alreadyEdit = true
    }
  }

  get isApprove(){
    return this.info.isIdentification =='1'
  }

  getCompanyDtl () {
    GetCompanyDtl({}).then(res => {
      this.companyMsg = res.data
      this.companyMsg.imageBase64Url = downloadUrl(this.companyMsg.logoUrl)
      if (this.companyMsg.accountList.length > 0) {
        this.companyMsg.accountList.map(item => {
          item.accountShow = false
        })
      }
    })
  }

  // 行业选择弹框确认
  industryConfirm (value: DictDataDto) {
    this.companyMsg.industryId = value.dataId
    this.companyMsg.industryName = value.dataName
    this.showIndustryPicker = false
  }

  /**
   * 银行选择弹框取消
   */
  banckCancel (index: number, item: accountListOTD,) {
    item.accountShow = false
    this.$set(this.companyMsg.accountList, index, item)
  }

  /**
   * 银行选择弹框确认
   */
  bankConfirm (index: number, item: accountListOTD, value: any) {
    item.accountBank = value.bankName
    item.accountShow = false
    this.$set(this.companyMsg.accountList, index, item)
  }

  /**
   * 银行选择弹框打开
   */
  handleAccountShow (index: number, item: accountListOTD) {
    item.accountShow = true
    this.$set(this.companyMsg.accountList, index, item)
  }

  /**
   * 获取选项数据【字典接口】
   * @param name 查询参数
   * @param list 存放地址(Array类型)
   */
  dictList () {
    let param = {
      dictTypeId: 'industry'
    }
    getSyDictDataInfo(param).then(res => {
      this.industryList = res.data
    })
  }


  getBanckCards () {
    getBankListInfo({}).then(res => {
      this.banckCards = res.data
    })
  }

  // 银行账户添加
  addAccount () {
    this.companyMsg.accountList.push({
      accountName: '',
      accountBank: undefined,
      accountId: ''
    })
  }

  deleteAccount (index) {
    if (this.companyMsg.accountList.length === 1) {
      this.$toast('银行信息至少有一条')
      return
    }
    this.companyMsg.accountList.splice(index, 1)
  }

  // 收货地址添加
  addAddr () {
    this.companyMsg.addressList.push({
      addressName: '',
      addressId: '',
      isDefault: '0',
      addressDtl: '',
      receiveMobile: '',
      receiveMan: ''
    })
  }


  deleteAddr (index) {
    if (this.companyMsg.addressList.length === 1) {
      this.$toast('收货地址至少有一条')
      return
    }
    if (this.companyMsg.addressList[index].isDefault === '1') {
      this.$toast('当前收货地址为默认地址')
      return
    }
    this.companyMsg.addressList.splice(index, 1)
  }

  handleEdit () {
    this.isEdit = true
    if (this.companyMsg.addressList.length === 0) {
      this.companyMsg.addressList.push({
        addressName: '',
        addressId: '',
        isDefault: '1',
        addressDtl: '',
        receiveMobile: '',
        receiveMan: ''
      })
    }
    if (this.companyMsg.accountList.length === 0) {
      this.companyMsg.accountList.push({
        accountName: '',
        accountBank: undefined,
        accountId: ''
      })
    }
  }

  /**
   * 公司基本信息的地址信息改变
   */
  handleAddrChange ({addressId, addressName}) {
    this.$set(this.companyMsg, 'addressId', addressId)
    this.$set(this.companyMsg, 'addressName', addressName)
  }

  /**
   * 公司收货地址信息改变
   * @param addressId
   * @param addressName
   * @param index
   */
  handleAddressChange ({addressId, addressName}, item, index) {
    item.addressId = addressId
    item.addressName = addressName
    this.$set(this.companyMsg.addressList, index, item)
  }

  /**
   * 设置默认地址
   * @param value
   * @param item
   * @param index
   */
  handleDefaultAddr (value: string, item: addressListOTD, index: number) {
    let list = this.companyMsg.addressList
    if (value === '1') { // 设置当前地址为收货地址
      if (list) {
        list.map(i => {
          i.isDefault = '0'
        })
      }
      item.isDefault = '1'
    } else if (this.companyMsg.addressList.length === 1) { // 当收货地址只有一条时
      item.isDefault = '1'
      this.$toast('默认收货地址应当有且仅有一个')
    } else if (index === this.companyMsg.addressList.length - 1) { // 当前地址为收货地址最后一条时  取消当前则第一条收货地址为默认地址
      item.isDefault = '0'
      this.companyMsg.addressList[0].isDefault = '1'
    } else { // 当前收货地址取消时,设置下一条为收货地址
      item.isDefault = '0'
      this.companyMsg.addressList[index + 1].isDefault = '1'
    }
    this.$set(this.companyMsg.addressList, index, item)
  }

  /**
   * 获取用户手机通讯录
   * (跟原生对接)
   */
  handleContacts (item: addressListOTD, index: number) {
    openAddressbook().then((res: { name?: string; mobile?: string }) => {
      console.log(res)
      if (res && res.name) {
        item.receiveMan = res.name
      }
      if (res && res.mobile) {
        item.receiveMobile = res.mobile
      }
      this.$set(this.companyMsg.addressList, index, item)
    })
  }

  saveSure () {
    (this.$refs.handleForm as any).validate().then(() => {
      if (!this.companyMsg.accountList || this.companyMsg.accountList!.length === 0) {
        this.$toast('至少填写一条银行信息')
        return false
      } else if (!this.companyMsg.addressList || this.companyMsg.addressList!.length === 0) {
        this.$toast('至少填写一条收货信息')
        return false
      } else {
        ModifyCompanyBase(this.companyMsg).then((res) => {
          this.$toast.success({
            message: '保存成功',
            duration: 1000,
            onClose: () => {
              this.getCompanyDtl()
              this.isEdit = false
            }
          })
        })
      }
    })
  }

  /**
   * h5返回原生上一级
   */
  handleBack () {
    if (this.alreadyEdit && this.isEdit) {
      this.$confirmDialog.show({
        okText: '确认',
        cancelText: '取消',
        tips: '现在退出则不会保存已修改内容，是否确认退出?',
        onOk: () => {
          backToBefore()
        },
      })
    } else {
      backToBefore()
    }
  }

  /**
   * 监听原生APP的返回事件
   */
  handleAppBack() {
    this.$bridge.registerHandler(
        "companyMsgBack",() => {
          this.handleBack()
        }
    );
  }
}
